type RuntimeConfig = {
	BASE_API_URL: string;
	GR8_URL: string;
	API_KEY: string;
	BRAND: string;
	BRAND_THEME: string;
	ENV: string;
	GTM_ID: string;
	GTM_NOSCRIPT_SRC: string;
};

declare global {
	interface Window {
		__CONFIG__?: RuntimeConfig;
	}
}

function getConfig(): RuntimeConfig {
	if (typeof window !== 'undefined' && window.__CONFIG__) {
		return window.__CONFIG__;
	}

	return {
		BASE_API_URL: import.meta.env.VITE_BASE_API_URL,
		GR8_URL: import.meta.env.VITE_GR8_URL,
		API_KEY: import.meta.env.VITE_API_KEY,
		BRAND: import.meta.env.VITE_BRAND,
		BRAND_THEME: import.meta.env.VITE_BRAND_THEME,
		ENV: import.meta.env.VITE_ENV,
		GTM_NOSCRIPT_SRC: import.meta.env.VITE_GTM_NOSCRIPT_SRC,
		GTM_ID: import.meta.env.VITE_GTM_ID
	};
}

export const config = getConfig();
